import { HALApiService } from '../hal-api.service'
import { createItemsData } from '../../helpers/request-helpers'
import { CachedService } from './base-service'
import entities from '../../../../config/Entities'

export const assemblingTasksService = new CachedService(entities.Orderadmin_Storage_Entity_Assemblage_Task, '/storage/assembling/task', HALApiService, createItemsData)
